import {createContext} from 'react';

export interface DfpAdContextValue {
	//
	/**
	 * Is DFP service is enabled
	 * It is enabled after the first application render in order to collect all slot defines
	 * for the correct operation of the single request architecture
	 */
	serviceEnabled: boolean;
}

export const DfpAdContext = createContext<DfpAdContextValue | null>(null);
DfpAdContext.displayName = 'DfpAdContext';
